import React from 'react';
import { Dialog, DialogTitle, DialogContent, Grid } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { StyledDialogActions } from 'containers/AttributionManager/styles';
import { translate } from 'containers/services/translate';
import messages from 'containers/ExpertExpertise/messages';
import CloseIconBlack from 'components/SahamIcons/CloseIconBlack';
import { COLORS } from 'constants/design';

export interface DialogManagerProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  title: string;
  content: any;
  disabled: boolean;
}

const DialogManager: React.FC<DialogManagerProps> = (props): JSX.Element => {
  const { onClose, open } = props;

  return (
    <Dialog
      onClose={() => onClose()}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        <Grid container direction="row" spacing={3}>
          <Grid item xs={11}>
            {props.title}
          </Grid>
          <Grid item>
            <CloseIconBlack onClick={() => onClose()} />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>{props.content}</DialogContent>
      <StyledDialogActions>
        <SecondaryButton
          onClick={() => props.onClose()}
          disableElevation
          data-testid="cancel-button"
          title={translate({ ...messages.dialogCancelButton }, props)}
          titlecolor={COLORS.PRIMARY_BUTTON_BLUE}
          border={COLORS.LIGHT_WHITE_GREY}
        />
        <PrimaryButton
          onClick={() => props.validateDialog()}
          disableElevation
          data-testid="validate-button"
          title={translate({ ...messages.dialogValidationButton }, props)}
          disabled={props.disabled}
          background={COLORS.PRIMARY_BUTTON_BLUE}
          titlecolor={COLORS.WHITE}
          border={COLORS.PRIMARY_BUTTON_BLUE}
        />
      </StyledDialogActions>
    </Dialog>
  );
};

DialogManager.defaultProps = {
  open: false,
};

export default injectIntl(DialogManager);
